import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../auth.service';
import { tap } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  return authService.canActivateProtectedRoutes$.pipe(
    tap((allowed) => {
      if (!allowed) {
        authService.navigateToLoginPage(state.url);
      }
    }),
  );
};
